import React, { useState } from "react";

import { useApi } from "../../../../../api";
import { setFieldErrorsFromResponse } from "../../../../../utils/formErrors";
import useI18nSnackbar from "../../../../../hooks/useI18nSnackbar";
import CommentList from "./CommentList";
import CommentForm from "./CommentForm";
import DeleteContainer from "./DeleteContainer";

const DEFAULT_COMMENT_LIMIT = 5;

const CommentContainer = ({ device, onClose }) => {
  const api = useApi();
  const { enqueueSnackbar } = useI18nSnackbar();

  const [comments, setComments] = useState(device.comments || []);
  const [isRefreshing, setRefreshing] = useState(false);
  const [editingComment, setEditingComment] = useState(undefined);
  const [confirmDeleteComment, setConfirmDeleteComment] = useState(null);

  const commentLimit = device.commentLimit || DEFAULT_COMMENT_LIMIT;

  const refreshComments = () => {
    setRefreshing(true);

    return api.get(`/v2/devices/${device.id}/comment`).then(response => {
      setComments(response.data);
      setRefreshing(false);
    });
  };

  const handleSubmit = (values, { setSubmitting, setFieldError }) => {
    const request = editingComment
      ? api.put(`/v2/devices/${device.id}/comment/${editingComment.id}`, values)
      : api.post(`/v2/devices/${device.id}/comment`, values);

    request
      .then(() => {
        enqueueSnackbar(
          editingComment
            ? "devices.settings.metadata.comment.responses.updated"
            : "devices.settings.metadata.comment.responses.created",
          { variant: "success" }
        );

        setEditingComment(undefined);
        refreshComments();
      })
      .catch(e => {
        if (!e.response) {
          return;
        }

        setSubmitting(false);
        setFieldErrorsFromResponse(e.response, setFieldError);
      });
  };

  const handleDeleted = () => {
    enqueueSnackbar("devices.settings.metadata.comment.responses.deleted", {
      variant: "success"
    });

    setConfirmDeleteComment(null);
    refreshComments();
  };

  if (editingComment !== undefined) {
    return (
      <CommentForm
        values={{ comment: editingComment ? editingComment.comment : "" }}
        onCancel={() => setEditingComment(undefined)}
        onSubmit={handleSubmit}
      />
    );
  }

  return (
    <>
      {confirmDeleteComment !== null && (
        <DeleteContainer
          deviceId={device.id}
          commentId={confirmDeleteComment.id}
          onCancel={() => setConfirmDeleteComment(null)}
          onDeleted={handleDeleted}
        />
      )}
      <CommentList
        comments={comments}
        commentLimit={commentLimit}
        isRefreshing={isRefreshing}
        onAdd={() => setEditingComment(null)}
        onEdit={comment => setEditingComment(comment)}
        onDelete={comment => setConfirmDeleteComment(comment)}
        onClose={() => onClose(true)}
      />
    </>
  );
};

export default CommentContainer;
